import { ColumnDef } from '@tanstack/react-table'
import { IAddress, IClient, IOrder } from '../models/models'
import Status from '../components/UI/Status'
import dateFormat from 'dateformat'
import { formatPhone } from '../helpers'

export const clientsColumns: ColumnDef<IClient>[] = [
	{
		accessorKey: 'userId',
		header: 'id клієнта',
	},
	{
		accessorKey: 'status',
		header: 'Статус',
		cell: (value) => <Status type={value.getValue<any>()} />,
	},
	{
		accessorKey: 'name',
		header: 'ПІБ/Назва',
		minSize: 300,
	},
	{
		accessorKey: 'phone',
		header: 'Номер телефону',
		enableSorting: false,
		cell: (value) => formatPhone(value.getValue<any>()) || '-',
	},
	{
		accessorKey: 'email',
		header: 'E-mail',
		enableSorting: false,
		minSize: 200,
	},
	{
		accessorKey: 'registeredAt',
		header: 'Дата реєстрації',
		cell: (value) => dateFormat(value.getValue<any>(), 'dd.mm.yyyy'),
	},
	{
		accessorKey: 'code',
		header: 'РНОКПП',
		enableSorting: false,
	},
	{
		accessorKey: 'birthdate',
		header: 'Дата народження',
		cell: (value) => dateFormat(value.getValue<any>(), 'dd.mm.yyyy'),
	},
	{
		accessorKey: 'address',
		header: 'Адреса',
		enableSorting: false,
		minSize: 300,
	},
	{
		accessorKey: 'region',
		header: 'Регіон',
		cell: (value) => value.row.original.region.name,
	},
]

export const addressesColumns: ColumnDef<IAddress>[] = [
	{
		accessorKey: 'name',
		header: 'Адреса',
		minSize: 300,
		cell: (value) => value.getValue<any>() || '-',
	},
	{
		accessorKey: 'point',
		header: 'Координати',
		enableSorting: false,
		cell: ({ row }) => (
			<a
				href={`http://www.google.com/maps/place/${row.original.point.latitude},${row.original.point.longitude}`}
				target={'_blank'}
				style={{
					textDecoration: 'none',
					color: '#2F80ED',
				}} rel="noreferrer"
			>
				{row.original.point.latitude} <br /> {row.original.point.longitude}
			</a>
		),
	},
	{
		accessorKey: 'userComment',
		header: 'Коментарі',
		enableSorting: false,
		cell: (value) => value.getValue<any>() || '-',
	},
	{
		accessorKey: 'ordersCount',
		header: 'Кількість замовлень',
	},
]

export const ordersColumns: ColumnDef<IOrder>[] = [
	{
		accessorKey: 'date',
		header: 'Дата',
		cell: (value) => dateFormat(value.getValue<any>(), 'dd.mm.yyyy'),
	},
	{
		accessorKey: 'id',
		header: 'ID',
	},
	{
		accessorKey: 'totalCost',
		header: 'Сума',
		cell: (value) => Number(value.getValue<any>()) / 100,
	},
	{
		accessorKey: 'fuelAmount',
		header: 'Замовлено дизелю',
	},
	{
		accessorKey: 'filledFuelAmount',
		header: 'Заправлено дизелю',
	},
	{
		accessorKey: 'adblueAmount',
		header: 'Замовлено AdBlue',
	},
	{
		accessorKey: 'filledAdblueAmount',
		header: 'Заправлено AdBlue',
	},
	{
		accessorKey: 'id',
		header: 'Номер замовлення',
	},
	{
		accessorKey: 'distanceKm',
		header: 'Дістанція/км',
		enableSorting: false,
	},
	{
		accessorKey: 'pickupMode',
		header: 'Тип замовлення',
		cell: (value) => (value.getValue<any>() ? 'самовивіз' : 'доставка'),
	},
	{
		accessorKey: 'cancelledBy',
		header: 'Хто відмінив',
		cell: (value) => value.getValue<any>() || '-',
		enableSorting: false,
	},
	{
		accessorKey: 'userFio',
		header: 'Клієнт',
		cell: (value) => value.getValue<any>() || '-',
		minSize: 250,
		enableSorting: false,
	},
	{
		accessorKey: 'status',
		header: 'Статус замовлення',
		cell: (value) => <Status type={value.getValue<any>()} />,
	},
]
